import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateManagedMeetingTemplateAssignments as UpdateManagedMeetingTemplateAssignmentsMutation,
    UpdateManagedMeetingTemplateAssignmentsVariables as UpdateManagedMeetingTemplateAssignmentsVariables,
    ManagedMeetingTemplateAssignmentsUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_MANAGED_MEETING_TEMPLATE_ASSIGNMENTS from '../mutations/update-managed-meeting-template-assignments.graphql';

export const useUpdateManagedMeetingTemplateAssignments = (): {
    updateManagedMeetingTemplateAssignments: (
        arg1: ManagedMeetingTemplateAssignmentsUpdateInput
    ) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateManagedMeetingTemplateAssignments, {loading, error}] = useMutation<
        UpdateManagedMeetingTemplateAssignmentsMutation,
        UpdateManagedMeetingTemplateAssignmentsVariables
    >(UPDATE_MANAGED_MEETING_TEMPLATE_ASSIGNMENTS, {
        refetchQueries: ['GetMeeting'],
    });

    return {
        updateManagedMeetingTemplateAssignments: (
            input: ManagedMeetingTemplateAssignmentsUpdateInput
        ) => updateManagedMeetingTemplateAssignments({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
